import { ButtonSelection } from "./types"
import { getButtonType } from "./button"

export const append = (buttonElement) => {
  if (getButtonType(buttonElement) !== "image") {
    buttonElement
      .append("foreignObject")
      .classed("dashboard-button-html-container", true)
      .classed("overflow-visible", true)
      .classed("pe-none", true)
      .attr("pointer-events", "none")
      .attr("x", 0)
      .attr("y", 0)
      .style("font-size", "20pt")
      .append("xhtml:div")
      .classed("dashboard-button-html-foreign-object-root", true)
      .classed("pe-none", true)
      // do not use `position` (!!)
      // Safari bug: https://github.com/bkrem/react-d3-tree/issues/284
      // .classed("position-fixed", true)
      .classed("h-100", true)
      .classed("w-100", true)
      .classed("p-1", true)
      .classed("d-flex", true)
      .classed("align-items-center", true)
      .classed("justify-content-stretch", true)
      .style("inset", 0)
      .append("div")
      .classed("dashboard-button-html", true)
      .classed("flex-grow-1", true)
      .append("p")
      .style("text-align", "center")
      .style("word-wrap", "break-word")
      .text("text")
    computeAttributes(buttonElement)
  }
}

export const computeAttributes = (buttonElement) => {
  const datum = buttonElement.datum()
  buttonElement
    .selectAll(".dashboard-button-html-container")
    ?.attr("width", datum.width)
    ?.attr("height", datum.height)
}

export const setHtml = (buttonElement: ButtonSelection, html: string) => {
  buttonElement.select(".dashboard-button-html")?.html(html)
}

export const getHtml = (buttonElement: ButtonSelection) => {
  const htmlElement = buttonElement.select(".dashboard-button-html")
  if (htmlElement?.size()) {
    return htmlElement.html()
  }
  return undefined
}
